(function () {
  'use strict';

  // Sticky header scrolled state
  const header = document.getElementById('SiteHeader');
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 60) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Scroll reveal
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.reveal').forEach((el) => io.observe(el));
  } else {
    document.querySelectorAll('.reveal').forEach((el) => el.classList.add('visible'));
  }

  // Quick-add (form submit via fetch to /cart/add.js)
  document.querySelectorAll('.product-card__quick-add').forEach((btn) => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;
      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      const originalLabel = btn.textContent;
      btn.textContent = 'Hinzufügen…';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (!res.ok) throw new Error('add to cart failed');

        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        document.querySelectorAll('.cart-count, #CartCount').forEach((el) => (el.textContent = String(cart.item_count)));

        // Notify global-components.js so it refreshes drawer + opens
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, openDrawer: true } }));

        btn.textContent = '✓ Hinzugefügt!';
        btn.classList.add('success');
      } catch (err) {
        btn.textContent = 'Fehler — erneut versuchen';
      } finally {
        setTimeout(() => {
          btn.textContent = originalLabel;
          btn.disabled = false;
          btn.classList.remove('success');
        }, 1800);
      }
    });
  });

  // Prevent inner Kaufen-button-as-span from following the card link twice
  document.querySelectorAll('.product-card__overlay .product-card__quick-add').forEach((btn) => {
    btn.closest('a')?.addEventListener('click', (e) => {
      if (e.target.closest('.product-card__quick-add')) e.preventDefault();
    });
  });
})();
